import { useYMapEntries } from './useYMapEntries';
import { yElements } from '../schema';
import { getDiagramDoc } from '../doc';

export function useElements() {
    const doc = getDiagramDoc();
    return useYMapEntries(doc ? yElements(doc) : null);
}
